import { render, staticRenderFns } from "./AttachPolicyModal.vue?vue&type=template&id=41f58cd0&scoped=true"
import script from "./AttachPolicyModal.vue?vue&type=script&lang=js"
export * from "./AttachPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./AttachPolicyModal.vue?vue&type=style&index=0&id=41f58cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f58cd0",
  null
  
)

export default component.exports